import { i18n } from '@/common/utils/i18n'

export const SIGN_COUNTRY_LIST = [
  {
    label: i18n.gettext('墨西哥'),
    value: 'MX'
  }
]
export const SIGN_PARTY_TYPE_LIST = [
  {
    label: i18n.gettext('普通商家'),
    value: 1
  },
  {
    label: i18n.gettext('CKA'),
    value: 2
  },
  {
    label: i18n.gettext('KA'),
    value: 3
  }
]

export const SIGN_PARTY_TYPE_NORMAL_OPTIIN = {
  label: i18n.gettext('普通商家'),
  value: 1
}

export const SIGN_PARTY_TYPE_CKA_OPTIIN = {
  label: i18n.gettext('CKA'),
  value: 2
}

export const SIGN_PARTY_TYPE_KA_OPTIIN = {
  label: i18n.gettext('KA'),
  value: 3
}

export const SIGN_PARTY_TYPE_MAP = {
  1: i18n.gettext('普通商家'),
  2: i18n.gettext('CKA'),
  3: i18n.gettext('KA')
}

export const SIGN_DELIVERY_TYPE_LIST = [
  {
    label: i18n.gettext('支持'),
    value: 1
  },
  {
    label: i18n.gettext('不支持'),
    value: 2
  }
]

export const SIGN_PARTYA_TITLE_LIST = [
  {
    value: 1,
    text: i18n.gettext('合法代表')
  },
  {
    value: 2,
    text: i18n.gettext('董事')
  },
  {
    value: 3,
    text: i18n.gettext('授权人')
  },
  {
    value: 4,
    text: i18n.gettext('其他')
  }
]

export const SIGN_LEGAL_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('新版')
  },
  {
    value: 2,
    text: i18n.gettext('老版无Curp')
  },
  {
    value: 3,
    text: i18n.gettext('老版有Curp')
  }
]
export const SIGN_AUTHORIZATION_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('签约授权书')
  },
  {
    value: 2,
    label: i18n.gettext('打款授权书')
  },
  {
    value: 3,
    label: i18n.gettext('品牌授权书')
  }
]

export const SIGN_CONTRACT_TEMPLATE_TYPE_LIST = [
  {
    value: 1,
    label: i18n.gettext('标准合同模板')
  }
]

export const SIGN_SHOP_STATUS_MAP = {
  0: i18n.gettext('信息未完善'),
  1: i18n.gettext('信息已完善')
}
export const SIGN_SHOP_STATUS_TYPE_MAP = {
  0: 'warning',
  1: 'success'
}

export const SIGN_PACK_AUDIT_STATUS_MAP = {
  1: i18n.gettext('审核中'),
  2: i18n.gettext('审核失败'),
  3: i18n.gettext('审核完成')
}
export const SIGN_PACK_AUDIT_STATUS_TYPE_MAP = {
  1: 'warning',
  2: 'danger',
  3: 'success'
}

export const SIGN_AUDIT_STATUS_MAP = {
  2: i18n.gettext('审核中'),
  3: i18n.gettext('审核失败'),
  4: i18n.gettext('审核完成'),
  5: i18n.gettext('审核通过')
}

export const SIGI_DISABLED_STATUS_LIST = [2, 4, 5]

export const SIGN_AUDIT_STATUS_TYPE_MAP = {
  1: 'info',
  2: 'warning',
  3: 'danger',
  4: 'success',
  5: 'success'
}

export const SIGN_PACK_TO_TAB_MAP = {
  soda_restaurant: 'basic',
  soda_restaurant_license: 'qualification',
  soda_restaurant_contract: 'contract',
  soda_restaurant_legal: 'contract'
}

export const SIGN_CONTRACT_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('标准合同模板')
  }, {
    value: 2,
    text: i18n.gettext('佣金策略合同模板')
  }
]

export const SIGN_CONTRACT_VERSION_MAP = {
  1: '1.0'
}

export const SIGN_CONTRACTOR_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('股份有限公司')
  },
  {
    value: 2,
    text: i18n.gettext('有限责任公司')
  },
  {
    value: 3,
    text: i18n.gettext('个人')
  }
]

export const SIGN_PACK_DRAFT_STATUS_MAP = {
  UNSAVED: 1,
  SAVED: 2
}

export const PACK_NUM_1 = 'soda_restaurant'
export const PACK_NUM_2 = 'soda_restaurant_license'
export const PACK_NUM_3 = 'soda_restaurant_contract'
export const PACK_NUM_4 = 'soda_restaurant_legal'

export const PACK_NUM_1_KEYS = ['name', 'logo']
export const PACK_NUM_2_KEYS = [
  // 'resName',
  // 'resAddr',
  // 'licenseNum',
  // 'scope',
  // 'openDate',
  // 'validateDate',
  'licensePics'
]
export const PACK_NUM_3_KEYS = [
  'contractNo',
  'partyaName',
  // 'partyaRegisteAddr',
  'partyaEmail',
  'partyaContact',
  'partyaPhone',
  'accountHolder',
  'accountAddr',
  'accountCardno',
  // accountBankName
  // 'financeChief',
  // 'financePhone',
  // 'financeEmail',
  'oneselfType',
  'platformType',
  'oneselfRate',
  'platformRate'
]
export const PACK_NUM_4_KEYS = ['legalName', 'legalType', 'legalId', 'legalPics', 'legalExtra']

export const CATEGORY_MAP = {
  1: ['basic'],
  2: ['qualification'],
  3: ['contract'],
  4: ['contractorOther', 'shopOther', 'other']
}

// 启动费金额 梯度
export const STARTUP_MONEY_SELECT_LIST_CONFIG = [
  {
    text: '0',
    value: 0
  },
  {
    text: '500',
    value: 50000
  },
  {
    text: '1000',
    value: 100000
  },
  {
    text: '1500',
    value: 150000
  },
  {
    text: '2000',
    value: 200000
  },
  {
    text: '2500',
    value: 250000
  },
  {
    text: '3000',
    value: 300000
  },
  {
    text: '3500',
    value: 350000
  },
  {
    text: '4000',
    value: 400000
  },
  {
    text: '4500',
    value: 450000
  },
  {
    text: '5000',
    value: 500000
  }
]

// 设备信息： 是否需要pad
export const EQUIPMENT_INFO_PAD_SELECT_LIST = [
  {
    text: i18n.gettext('需要'),
    value: 1
  },
  {
    text: i18n.gettext('不需要'),
    value: 0
  }
]

// 默认合同版本 2.0
export const DEFAULT_CONTRACT_VERSOIN = '2.0'

export const BIZOPP_STATUS_OPTIONS = [
  {
    label: i18n.gettext('跟进中'),
    value: 1,
    tagType: 'info'
  },
  {
    label: i18n.gettext('草稿中'),
    value: 2,
    tagType: 'info'
  },
  {
    label: i18n.gettext('审批中'),
    value: 3,
    tagType: 'info'
  },
  {
    label: i18n.gettext('审批失败'),
    value: 4,
    tagType: 'danger'
  },
  {
    label: i18n.gettext('已签约'),
    value: 5,
    tagType: 'success'
  },
  {
    label: i18n.gettext('无效'),
    value: 6,
    tagType: 'danger'
  },
  {
    label: i18n.gettext('审批通过'),
    value: 8,
    tagType: 'success'
  },
  {
    label: i18n.gettext('已核准'),
    value: 9,
    tagType: 'success'
  },
  {
    label: i18n.gettext('已签章'),
    value: 10,
    tagType: 'success'
  }
]

export const PARTY_STATUS_MAP = [
  {
    label: i18n.gettext('草稿中'),
    value: 0
  },
  {
    label: i18n.gettext('审批中'),
    value: 1
  },
  {
    label: i18n.gettext('审批失败'),
    value: 2
  },
  {
    label: i18n.gettext('审批通过'),
    value: 5
  },
  {
    label: i18n.gettext('已核准'),
    value: 6
  },
  {
    label: i18n.gettext('已签章'),
    value: 7
  },
  {
    label: i18n.gettext('已签约'),
    value: 3
  },
  {
    label: i18n.gettext('无效'),
    value: 4
  }
]
